function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "cover-upload",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M8,13 L12,9 L16,13 L13.4499998,13 L13.4499998,16 L10.5500002,16 L10.5500002,13 L8,13 Z M12,4 C15.7484589,4 18.894783,6.57805037 19.7626076,10.0577888 C22.1620731,10.4249945 24,12.4978609 24,15 C24,17.7614241 21.7614231,20 19,20 L6,20 C2.68629146,20 0,17.3137083 0,14 C0,11.0181799 2.17514133,8.54439116 5.02528524,8.07877207 C6.39696312,5.64419317 9.00647068,4 12,4 C14.4989726,4 14.4989726,4 12,4 Z M5.34774446,10.0526061 L6.29607821,9.89767981 L6.76775455,9.06050539 C7.79943895,7.22937846 9.75745869,6 12,6 C14.8086548,6 17.1711197,7.93171453 17.8220463,10.5417523 L18.1441727,11.8333941 L19.4600563,12.0347719 C20.8979931,12.2548285 22,13.5005455 22,15 C22,16.6568546 20.6568546,18 19,18 L6,18 C3.79086089,18 2,16.2091389 2,14 C2,12.01406 3.44923735,10.3627591 5.34774446,10.0526061 L5.34774446,10.0526061 Z",
  id: "file-/-cloud_up",
  fill: "#FFFFFF"
}));

function SvgCoverUpload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "cover-upload") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoverUpload);
export default __webpack_public_path__ + "static/media/cover-upload.d4516c02.svg";
export { ForwardRef as ReactComponent };